import { dataColumn, dataDefault } from '../../../types/typesVPO';

export const FILTER_CONFIG = {
  columnPlanAction: {
    title: 'Колонна',
    options: [],
    searchPlaceholder: 'Найти колонну',
  },
  groupPlan: {
    title: 'Группа',
    options: [],
    hasSearch: false,
  },
  factory: {
    title: 'Завод',
    options: [],
    hasSearch: false,
  },
  columnBlock: {
    title: 'Блок колонны',
    options: [],
    searchPlaceholder: 'Найти блок колонны',
  },

  demand: {
    title: 'Требование',
    options: [],
    searchPlaceholder: 'Найти требование',
  },
  process: {
    title: 'Процесс',
    options: [],
    searchPlaceholder: 'Найти процесс',
  },
  level: {
    title: 'Уровень зрелости',
    options: ['0', 'I', 'II', 'III', 'IV'],
    hasSearch: false,
  },
  subdivision: {
    title: 'Подразделение',
    options: [],
    searchPlaceholder: 'Найти подразделение',
  },
  created: {
    title: 'Дата создания действия',
    hasSearch: false,
  },
  responsible: {
    title: 'Ответственный за действие',
    searchPlaceholder: '',
    hasSearch: false,
  },
  dataTable: {
    title: 'Срок выполнения действия',
    hasSearch: false,
  },
  status: {
    title: 'Статус действия',
    options: [],
    hasSearch: false,
  },

  meeting: {
    title: 'Название совещания',
    options: [],
    searchPlaceholder: 'Найти совещание',
  },
};

export const getInitialFilters = (context: any) => {
  const baseFilters = {
    created: { startDate: '', endDate: '' },
    dataTable: { startDate: '', endDate: '' },
    columnPlanAction: { selected: [], selectedIds: [], search: '' },
    columnBlock: { selected: [], selectedIds: [], search: '' },
    process: { selected: [], selectedIds: [], search: '' },
    level: { selected: [], selectedIds: [], search: '' },
    demand: { selected: [], selectedIds: [], search: '' },
    responsible: { selected: [], selectedIds: [], search: '' },
    subdivision: { selected: [], selectedIds: [], search: '' },
    status: { selected: ['Не начато', 'В процессе', 'Просрочено'], selectedIds: [227, 228, 229] },
    groupPlan: { selected: [], selectedIds: [] },
    factory: { selected: [], selectedIds: [] },
    meeting: { selected: [], selectedIds: [], search: '' },
  };

  if (context) {
    return {
      ...baseFilters,
      columnPlanAction: {
        selected: [context.currentColumn.title],
        selectedIds: [context.currentColumn.id],
      },
      groupPlan: {
        selected: [context.group.name],
        selectedIds: [context.group.id],
      },
      factory: {
        selected: [context.factory.name],
        selectedIds: [context.factory.id],
      }
    };
  }

  return baseFilters;
};

export const INITIAL_FILTERS_OPEN = {
  created: false,
  dataTable: false,
  columnPlanAction: false,
  groupPlan: false,
  columnBlock: false,
  process: false,
  level: false,
  demand: false,
  responsible: false,
  subdivision: false,
  status: false,
  factory: false,
  meeting: false,
};
